import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'ngx-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit  {
  
  constructor(private readonly keycloak: KeycloakService, private router: Router) {}

  ngOnInit(): void {

    this.keycloak.logout();
    this.router.navigate(['/login']);
       
  }
}
